import styles from '@components/Spot/Spot.module.scss';

const circleConfig = {
  signDesktop: {
    top: {
      width: 566,
      height: 566,
      className: styles.circle_sign_top,
    },
    bottom: {
      width: 614,
      height: 614,
      className: styles.circle_sign_bottom,
    },
  },
};

export const iconConfig = {
  heart: {
    mobile: {
      top: '-215px',
      left: '200px',
    },
    desktop: {
      top: '-40px',
      left: '290px',
    },
  },
  note: {
    mobile: {
      top: '-340px',
      left: '80px',
    },
    desktop: {
      top: '-160px',
      left: '80px',
    },
  },
  cross: {
    mobile: {
      top: '-370px',
      left: '-40px',
    },
    desktop: {
      top: '-140px',
      left: '-60px',
    },
  },
  car: {
    mobile: {
      top: '-170px',
      left: '-10px',
    },
    desktop: {
      top: '140px',
      left: '-32px',
    },
  },
};

export default circleConfig;
